import { io } from "socket.io-client";
import { getToken } from "./api";

let socket = null;

export function connectSocket() {
  if (socket?.connected) return socket;

  const token = getToken();
  if (!token) return null;

  socket = io("/live", {
    auth: { token },
    transports: ["websocket", "polling"],
  });

  socket.on("connect", () => {
    console.log("Live socket connected");
  });

  socket.on("connect_error", (err) => {
    console.error("Live socket connection error:", err.message);
  });

  return socket;
}

/**
 * Connect as a read-only watcher.
 *
 * The watch code stands in for the JWT — it is the whole credential, and the
 * server treats a socket carrying one as a spectator: it joins the `watch:`
 * room, receives id-stripped snapshots, and has none of the mutating handlers
 * wired to it. Shares the module-level socket so disconnectSocket/getSocket
 * behave the same either way; a watcher is signed out by definition, so there
 * is never a participant socket to clash with.
 */
export function connectWatchSocket(watchCode) {
  if (!watchCode) return null;
  if (socket?.connected) return socket;

  socket = io("/live", {
    auth: { watchCode },
    transports: ["websocket", "polling"],
  });

  socket.on("connect", () => {
    console.log("Live socket connected (watching)");
  });

  socket.on("connect_error", (err) => {
    console.error("Watch socket connection error:", err.message);
  });

  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

export function getSocket() {
  return socket;
}
